import type { tempCreateProductInput } from '_graphql/__generated__/globalTypes';

/** Supplier bulk upload matches ops payloads; only `supplier_id` is injected. */
export function enrichSupplierBulkProductInputs(
  products: tempCreateProductInput[],
  supplierId: string,
): tempCreateProductInput[] {
  return products.map((p) => ({ ...p, supplier_id: supplierId }));
}
